<template>
    <div>
        <v-checkbox
            :label="label"
            :color="color"
            :class="readOnly ? 'field no-pointer-events' : 'field'"
            :readonly="readOnly || this.value"
            :value="checkBoxValue"
            :disabled="disabled"
            @click="onClick"
        ></v-checkbox>
        <v-dialog
            v-if="dialog"
            v-model="dialog"
            persistent
            max-width="290"
        >
            <v-card>
                <v-card-title class="text-h5">
                    Είστε σίγουρος/η;
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red white--text"
                        @click="onNo"
                    >
                        ΑΚΥΡΩΣΗ
                    </v-btn>
                    <v-btn
                        color="black white--text"
                        @click="onYes"
                    >
                        Ναι
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: Boolean,
                required: true
            },
            readOnly: {
                type: Boolean,
                required: true
            },
            color: {
                type: String,
                required: false,
                default: () => { return 'green' }
            },
            label: {
                type: String,
                required: false,
                default: () => { return 'Ολοκληρώθηκε' }
            },
            changeBack: {
                type: Boolean,
                required: false,
                default: () => { return false }
            },
            disabled: {
                type: Boolean,
                required: false,
                default: () => { return false }
            }
        },
        watch: {
            value: {
                handler(newVal, oldVal) {
                    this.checkBoxValue = newVal
                }
            }
        },
        data() {
            return {
                dialog: false,
                checkBoxValue: false
            }
        },
        mounted() {
            this.checkBoxValue = this.value
        },
        methods: {
            onClick() {
                if (this.value && !this.changeBack) {
                    return
                }
                this.checkBoxValue = !this.checkBoxValue
                this.dialog = true
            },
            onYes() {
                this.dialog = false
                this.$emit('check-value-change', this.checkBoxValue)
            },
            onNo() {
                this.dialog = false
                this.checkBoxValue = !this.checkBoxValue
            }

        }
    }
</script>
<style scoped>
.field {
    font-weight: 800;
}
.no-pointer-events {
    pointer-events: none;
}

</style>
<style>
.v-label--is-disabled {
    color: lightgray !important;
}
</style>
